import { createSelector } from "@reduxjs/toolkit";
import { type RootState } from "features/Application/globaltypes/redux";
import { mapTagsToView } from "features/Library/Common/helpers/tagsHelper";
import { type TagsPayloadCamelPlural } from "interfaces/Tags";
import { type EmbeddedVideoFormFields } from "../../Details/EmbeddedVideoForm";
import { type EmbeddedVideoDetailsState } from "../EmbeddedVideoDetailsSlice";

export const normalizedTagsSelector = createSelector(
  [(state: RootState): TagsPayloadCamelPlural => state.library.embeddedVideos.tags.tags],
  mapTagsToView,
);

export const embeddedVideoFormFieldsSelector = createSelector(
  [(state: RootState) => state.library.embeddedVideos.details],
  (value: EmbeddedVideoDetailsState): EmbeddedVideoFormFields => ({
    title: value.embeddedVideo.title,
    description: value.embeddedVideo.description,
    videoUrl: value.embeddedVideo.videoUrl,
    source: value.embeddedVideo.source,
    thumbnailUrl: value.embeddedVideo.thumbnailUrl,
  }),
);
